import { useState } from 'react'
import Routes from './Routes'
import { ThemeContext } from './theme-context'
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material'

const darkTheme = createTheme({ palette: { mode: 'dark' } })
const lightTheme = createTheme({ palette: { mode: 'light' } })

function App() {
  const [isInDarkMode, setDarkMode] = useState(
    localStorage.getItem('isInDarkMode') === 'true'
  )

  const toggleDarkMode = () => {
    const newMode = !isInDarkMode
    setDarkMode(newMode)
    localStorage.setItem('isInDarkMode', newMode)
  }

  return (
    <ThemeProvider theme={isInDarkMode ? darkTheme : lightTheme}>
      <CssBaseline />
      <ThemeContext.Provider value={[isInDarkMode, toggleDarkMode]}>
        <Routes></Routes>
      </ThemeContext.Provider>
    </ThemeProvider>
  )
}

export default App
